module.exports = __webpack_public_path__ + "img/gb-whatsapp-update.0db5e179.webp";